import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useCreateCustomer } from '../../features/customers/api';
import './customers.scss';

interface CreateCustomerModalProps {
  onClose?: () => void;
  onInvited?: () => void;
}

export default function CreateCustomerModal({ onClose, onInvited }: CreateCustomerModalProps) {
  const [name, setName] = useState('');
  const createCustomer = useCreateCustomer();
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // lock scroll while open
    const { overflow } = document.body.style;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = overflow;
    };
  }, []);

  const submit = async () => {
    if (!name.trim()) {
      toast.error("Enter the customer's name.");
      return;
    }
    try {
      await createCustomer.mutateAsync({
        name: name.trim(),
      });
      toast.success('Customer created.');
      onInvited?.();
    } catch (e) {
      console.error(e);
      toast.error('Failed to create customer.');
    }
  };

  const onBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') onClose?.();
    if (e.key === 'Enter') submit();
  };

  return (
    <div
      className="modal"
      onClick={onBackdropClick}
      onKeyDown={onKeyDown}
      role="dialog"
      aria-modal="true"
      aria-labelledby="create-title"
    >
      <div className="modal__backdrop" onClick={onClose} />
      <div ref={panelRef} className="modal__panel" style={{ maxWidth: 420, width: '100%' }}>
        <div className="modal__header">
          <h3 id="create-title" className="modal__title">
            Create Customer
          </h3>
          <button className="btn btn--ghost" onClick={onClose}>
            Close
          </button>
        </div>

        <div className="modal__body">
          <div className="form-control">
            <label>Customer Name</label>
            <input
              type="text"
              placeholder="Customer Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
            />
          </div>
        </div>

        <div className="modal__footer">
          <div className="actions" style={{ gap: 8 }}>
            <button className="btn btn--ghost" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn--primary"
              onClick={submit}
              disabled={createCustomer.isPending}
            >
              {createCustomer.isPending ? 'Creating…' : 'Create Customer'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
